export default __webpack_public_path__ + "static/media/close-icon.d45d6164.svg";